export default __webpack_public_path__ + "static/media/app-logo.36878a09.svg";